export default "__VITE_ASSET__D$0x01eZ__"